{
    "reg_inquiry_Columns": [
        {
            "display": "true",
            "ui_columnname": "Action",
            "db_columnname": "action",
            "datatype": "char",
            "mappingkey": "action",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "false",
            "ui_columnname": "Inquiry ID",
            "db_columnname": "inquiryId",
            "datatype": "String",
            "mappingkey": "inquiryId",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "false",
            "ui_columnname": "queryId",
            "db_columnname": "queryId",
            "datatype": "char",
            "mappingkey": "queryId",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Status",
            "db_columnname": "status",
            "datatype": "String",
            "mappingkey": "status",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Inquiry Tag",
            "db_columnname": "tag",
            "datatype": "String",
            "mappingkey": "tag",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Inquiry Date",
            "db_columnname": "inquiryDate",
            "datatype": "date",
            "mappingkey": "inquiryDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "CATReporterIMID",
            "db_columnname": "CATReporterIMID",
            "datatype": "String",
            "mappingkey": "CATReporterIMID",
            "dropdown": "Yes",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Entity",
            "db_columnname": "entity",
            "datatype": "date",
            "mappingkey": "entity",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Event Type",
            "db_columnname": "eventType",
            "datatype": "String",
            "mappingkey": "eventType",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Event ID",
            "db_columnname": "eventId",
            "datatype": "String",
            "mappingkey": "eventId",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Event Time",
            "db_columnname": "eventTimestamp",
            "datatype": "String",
            "mappingkey": "eventTimestamp",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Trade Date",
            "db_columnname": "tradeDate",
            "datatype": "date",
            "mappingkey": "tradeDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "placeholder": "",
            "maxlength": "",
            "isrequired": true,
            "regexpressions": ""
        },
        {
            "display": "true",
            "ui_columnname": "Order ID",
            "db_columnname": "orderId",
            "datatype": "String",
            "mappingkey": "orderId",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "placeholder": "",
            "maxlength": "",
            "isrequired": true,
            "regexpressions": ""
        },
        {
            "display": "true",
            "ui_columnname": "LegID",
            "db_columnname": "legRefIDs",
            "datatype": "String",
            "mappingkey": "legRefIDs",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Route ID",
            "db_columnname": "routeId",
            "datatype": "String",
            "mappingkey": "routeId",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Trade ID",
            "db_columnname": "tradeId",
            "datatype": "String",
            "mappingkey": "tradeId",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Symbol",
            "db_columnname": "symbol",
            "datatype": "String",
            "mappingkey": "symbol",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Destination",
            "db_columnname": "destination",
            "datatype": "String",
            "mappingkey": "destination",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Side",
            "db_columnname": "sideId",
            "datatype": "String",
            "mappingkey": "side",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Quantity",
            "db_columnname": "quantity",
            "datatype": "float",
            "mappingkey": "quantity",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Price",
            "db_columnname": "price",
            "datatype": "float",
            "mappingkey": "price",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "TimeInForce",
            "db_columnname": "timeInForce",
            "datatype": "String",
            "mappingkey": "timeInForce",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Customer",
            "db_columnname": "customerID",
            "datatype": "String",
            "mappingkey": "customerID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Customer Type",
            "db_columnname": "customerType",
            "datatype": "String",
            "mappingkey": "customerType",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Destination",
            "db_columnname": "destination",
            "datatype": "String",
            "mappingkey": "destination",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Spl Handling Code",
            "db_columnname": "SplHandlingCode",
            "datatype": "String",
            "mappingkey": "SplHandlingCode",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "SolicitationFlag",
            "db_columnname": "solicitationFlag",
            "datatype": "Boolean",
            "mappingkey": "solicitationFlag",
            "dropdown": "NO",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display":"true",
            "ui_columnname":"LocateInfo",
            "db_columnname":"LocateInfo",
            "datatype":"String",
            "mappingkey":"LocateInfo",
            "dropdown":"NO",
            "disabled":"false",
            "value":"",
            "dropdowntype": "singleselect",
            "dropdownvalue":""
        },
        {
            "display": "false",
            "ui_columnname": "file Id",
            "db_columnname": "fileId",
            "datatype": "Int",
            "mappingkey": "fileId",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "File Name",
            "db_columnname": "File_Name",
            "datatype": "String",
            "mappingkey": "File_Name",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Inquiry Requestor",
            "db_columnname": "inquiryRequestor",
            "datatype": "String",
            "mappingkey": "inquiryRequestor",
            "dropdown": "Yes",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Create Date",
            "db_columnname": "createDate",
            "datatype": "String",
            "mappingkey": "createDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Update Date",
            "db_columnname": "updateDate",
            "datatype": "String",
            "mappingkey": "updateDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "User",
            "db_columnname": "lastUpdatedBy",
            "datatype": "String",
            "mappingkey": "lastUpdatedBy",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        }
    ],
    "inquiry_form_columns": [
        {
            "display": "false",
            "ui_columnname": "Inquiry ID",
            "db_columnname": "inquiryId",
            "datatype": "String",
            "mappingkey": "inquiryId",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "placeholder": "",
            "maxlength": "",
            "isrequired": false,
            "regexpressions": ""
        },
        {
            "display": "true",
            "ui_columnname": "Inquiry Tag",
            "db_columnname": "tag",
            "datatype": "String",
            "mappingkey": "tag",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "placeholder": "",
            "maxlength": "",
            "isrequired": true,
            "regexpressions": ""
        },
        {
            "display": "true",
            "ui_columnname": "Inquiry Date",
            "db_columnname": "inquiryDate",
            "datatype": "date",
            "mappingkey": "inquiryDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "placeholder": "",
            "maxlength": "",
            "isrequired": true,
            "regexpressions": ""
        },
        {
            "display": "false",
            "ui_columnname": "CATReporterIMID",
            "db_columnname": "CATReporterIMID",
            "datatype": "String",
            "mappingkey": "CATReporterIMID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "placeholder": "",
            "maxlength": "",
            "isrequired": false,
            "regexpressions": ""
        },
        {
            "display": "false",
            "ui_columnname": "File ID",
            "db_columnname": "fileId",
            "datatype": "String",
            "mappingkey": "fileId",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "placeholder": "",
            "maxlength": "",
            "isrequired": false,
            "regexpressions": ""
        },
        {
            "display": "true",
            "ui_columnname": "Requestor",
            "db_columnname": "inquiryRequestor",
            "datatype": "String",
            "mappingkey": "inquiryRequestor",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "placeholder": "",
            "maxlength": "",
            "isrequired": true,
            "regexpressions": ""
        },
        {
            "display": "true",
            "ui_columnname": "Status",
            "db_columnname": "status",
            "datatype": "String",
            "mappingkey": "status",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": "true",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "placeholder": "",
            "maxlength": "",
            "isrequired": false,
            "regexpressions": ""
        },
        {
            "display": "false",
            "ui_columnname": "Create Date",
            "db_columnname": "createDate",
            "datatype": "String",
            "mappingkey": "createDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": "",
            "placeholder": "",
            "maxlength": "",
            "isrequired": false,
            "regexpressions": ""
        },
        {
            "display": "false",
            "ui_columnname": "Update Date",
            "db_columnname": "updateDate",
            "datatype": "String",
            "mappingkey": "updateDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": "",
            "placeholder": "",
            "maxlength": "",
            "isrequired": false,
            "regexpressions": ""
        },
        {
            "display": "false",
            "ui_columnname": "User",
            "db_columnname": "lastUpdatedBy",
            "datatype": "String",
            "mappingkey": "lastUpdatedBy",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": "",
            "placeholder": "",
            "maxlength": "",
            "isrequired": false,
            "regexpressions": ""
        }
    ],
    "inquiry_comment_columns": [
        {
            "display": "false",
            "ui_columnname": "Action",
            "db_columnname": "isActive",
            "datatype": "char",
            "mappingkey": "isActive",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "false",
            "ui_columnname": "Comment ID",
            "db_columnname": "commentId",
            "datatype": "String",
            "mappingkey": "commentId",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Comment",
            "db_columnname": "comment",
            "datatype": "String",
            "mappingkey": "comment",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Status",
            "db_columnname": "isActive",
            "datatype": "String",
            "mappingkey": "isActive",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Last Updated Date",
            "db_columnname": "lastUpdatedOn",
            "datatype": "String",
            "mappingkey": "lastUpdatedOn",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Last Updated By",
            "db_columnname": "lastUpdatedBy",
            "datatype": "String",
            "mappingkey": "lastUpdatedBy",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        }
    ],
    "query_form_columns": [
        {
            "display": "true",
            "ui_columnname": "Action",
            "db_columnname": "action",
            "datatype": "char",
            "mappingkey": "action",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "false",
            "ui_columnname": "queryId",
            "db_columnname": "queryId",
            "datatype": "char",
            "mappingkey": "queryId",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "CATReporterIMID",
            "db_columnname": "CATReporterIMID",
            "datatype": "String",
            "mappingkey": "CATReporterIMID",
            "dropdown": "Yes",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "placeholder": "",
            "maxlength": "",
            "isrequired": true,
            "regexpressions": ""
        },
        {
            "display": "true",
            "ui_columnname": "Trade Date",
            "db_columnname": "tradeDate",
            "datatype": "date",
            "mappingkey": "tradeDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "placeholder": "",
            "maxlength": "",
            "isrequired": true,
            "regexpressions": ""
        },
        {
            "display": "true",
            "ui_columnname": "Order ID",
            "db_columnname": "orderId",
            "datatype": "String",
            "mappingkey": "orderId",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "placeholder": "",
            "maxlength": "",
            "isrequired": false,
            "regexpressions": ""
        },
        {
            "display": "true",
            "ui_columnname": "Route ID",
            "db_columnname": "routeId",
            "datatype": "String",
            "mappingkey": "routeId",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Trade ID",
            "db_columnname": "tradeId",
            "datatype": "String",
            "mappingkey": "tradeId",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Symbol",
            "db_columnname": "symbol",
            "datatype": "String",
            "mappingkey": "symbol",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Destination",
            "db_columnname": "destination",
            "datatype": "String",
            "mappingkey": "destination",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Query Status",
            "db_columnname": "status",
            "datatype": "String",
            "mappingkey": "status",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": "true",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "placeholder": "",
            "maxlength": "",
            "isrequired": false,
            "regexpressions": ""
        }
    ],
    "query_comment_columns": [
        {
            "display": "false",
            "ui_columnname": "Action",
            "db_columnname": "isActive",
            "datatype": "char",
            "mappingkey": "isActive",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "false",
            "ui_columnname": "Comment ID",
            "db_columnname": "commentId",
            "datatype": "String",
            "mappingkey": "commentId",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Comment",
            "db_columnname": "comment",
            "datatype": "String",
            "mappingkey": "comment",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Status",
            "db_columnname": "isActive",
            "datatype": "String",
            "mappingkey": "isActive",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Last Updated Date",
            "db_columnname": "lastUpdatedOn",
            "datatype": "String",
            "mappingkey": "lastUpdatedOn",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Last Updated By",
            "db_columnname": "lastUpdatedBy",
            "datatype": "String",
            "mappingkey": "lastUpdatedBy",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        }
    ],
    "inquiry_Columns": [
        {
            "display": "true",
            "ui_columnname": "Action",
            "db_columnname": "action",
            "datatype": "char",
            "mappingkey": "action",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "false",
            "ui_columnname": "Inquiry ID",
            "db_columnname": "inquiryId",
            "datatype": "String",
            "mappingkey": "inquiryId",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Inquiry Tag",
            "db_columnname": "tag",
            "datatype": "String",
            "mappingkey": "tag",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Inquiry Date",
            "db_columnname": "inquiryDate",
            "datatype": "date",
            "mappingkey": "inquiryDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "CATReporterIMID",
            "db_columnname": "CATReporterIMID",
            "datatype": "String",
            "mappingkey": "CATReporterIMID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "false",
            "ui_columnname": "file Id",
            "db_columnname": "fileId",
            "datatype": "Int",
            "mappingkey": "fileId",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "File Name",
            "db_columnname": "File_Name",
            "datatype": "String",
            "mappingkey": "File_Name",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Inquiry Requestor",
            "db_columnname": "inquiryRequestor",
            "datatype": "String",
            "mappingkey": "inquiryRequestor",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Status",
            "db_columnname": "status",
            "datatype": "String",
            "mappingkey": "status",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Create Date",
            "db_columnname": "createDate",
            "datatype": "String",
            "mappingkey": "createDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Update Date",
            "db_columnname": "updateDate",
            "datatype": "String",
            "mappingkey": "updateDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "User",
            "db_columnname": "lastUpdatedBy",
            "datatype": "String",
            "mappingkey": "lastUpdatedBy",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        }
    ],
    "inquiry_result_Columns": [
        {
            "display": "false",
            "ui_columnname": "Inquiry ID",
            "db_columnname": "inquiryId",
            "datatype": "String",
            "mappingkey": "inquiryId",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Inquiry Tag",
            "db_columnname": "tag",
            "datatype": "String",
            "mappingkey": "tag",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Entity",
            "db_columnname": "entity",
            "datatype": "date",
            "mappingkey": "entity",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Event Type",
            "db_columnname": "eventType",
            "datatype": "String",
            "mappingkey": "eventType",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Event ID",
            "db_columnname": "eventId",
            "datatype": "String",
            "mappingkey": "eventId",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Event Time",
            "db_columnname": "eventTimestamp",
            "datatype": "String",
            "mappingkey": "eventTimestamp",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Order ID",
            "db_columnname": "orderId",
            "datatype": "String",
            "mappingkey": "orderId",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Route ID",
            "db_columnname": "routeId",
            "datatype": "String",
            "mappingkey": "routeId",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Trade ID",
            "db_columnname": "tradeId",
            "datatype": "String",
            "mappingkey": "tradeId",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Symbol",
            "db_columnname": "symbol",
            "datatype": "String",
            "mappingkey": "symbol",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Side",
            "db_columnname": "sideId",
            "datatype": "String",
            "mappingkey": "side",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Quantity",
            "db_columnname": "quantity",
            "datatype": "float",
            "mappingkey": "quantity",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Price",
            "db_columnname": "price",
            "datatype": "float",
            "mappingkey": "price",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "TimeInForce",
            "db_columnname": "timeInForce",
            "datatype": "String",
            "mappingkey": "timeInForce",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Customer",
            "db_columnname": "customerID",
            "datatype": "String",
            "mappingkey": "customerID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Account Type",
            "db_columnname": "accountType",
            "datatype": "String",
            "mappingkey": "accountType",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Destination",
            "db_columnname": "destination",
            "datatype": "String",
            "mappingkey": "destination",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Spl Handling Code",
            "db_columnname": "SplHandlingCode",
            "datatype": "String",
            "mappingkey": "SplHandlingCode",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Create Date",
            "db_columnname": "createDate",
            "datatype": "String",
            "mappingkey": "createDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Update Date",
            "db_columnname": "updateDate",
            "datatype": "String",
            "mappingkey": "updateDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        }
    ]
}